/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { campaignDataStatusSchema } from './CampaignDataStatusSchema'

export const campaignDataSchema = z.object({
	form: z.object({
		id: z.string(),
		organisationId: z.string(),
		organisationName: z.string(),
		poolConsentUrl: z.string(),
		organisationRetentionMonths: z.number(),
		campaignId: z.string(),
		privacyUrl: z.string().nullable(),
		welcomeScreen: z.object({
			id: z.string(),
			title: z.string(),
			campaignId: z.string(),
			subtitle: z.string().nullable(),
			description: z.string().nullable(),
			descriptionHtml: z.string().nullable(),
			subtext: z.string().nullable(),
			imageId: z.string().nullable(),
			image: z.object({
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}).nullable(),
			imagesHistory: z.array(
				z.object({
					historyUpdatedAt: z.iso.datetime(),
					id: z.string(),
					name: z.string(),
					fileName: z.string(),
					category: z.union([z.literal('image'), z.literal('file')]),
					mimeType: z.string().nullable(),
					size: z.number(),
					humanReadableSize: z.string(),
					url: z.string(),
					collectionName: z.union([
						z.literal('ad-asset'),
						z.literal('baked-story'),
						z.literal('baked-feed'),
						z.literal('story'),
						z.literal('feed'),
						z.literal('landing-page'),
						z.literal('logo'),
						z.literal('generated'),
						z.literal('uploaded'),
						z.literal('imported'),
						z.literal('candidate-files'),
						z.literal('custom-font'),
						z.literal('design'),
						z.literal('whatsapp-profile'),
					]),
					width: z.number(),
					height: z.number(),
					isPlaceholder: z.boolean(),
					isGenerating: z.boolean(),
					createdAt: z.iso.datetime(),
					isGenerated: z.boolean().default(false),
					startedGenerationAt: z.iso.datetime().nullable(),
					finishedGenerationAt: z.iso.datetime().nullable(),
					meta: z.record(z.string(), z.unknown()).nullable(),
				}),
			),
			logo: z.object({
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}).nullable(),
			videoUrl: z.string().nullable(),
			updatedAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		language: z.string(),
		questions: z.array(
			z.object({
				id: z.string().nullable(),
				label: z.string(),
				type: z.union([
					z.literal('select'),
					z.literal('text'),
					z.literal('open_text'),
					z.literal('file'),
					z.literal('datetime'),
				]),
				attribute: z.union([
					z.literal('name'),
					z.literal('email'),
					z.literal('phone'),
					z.literal('contact_consent'),
					z.literal('cv'),
				]).nullable(),
				subtype: z.union([z.literal('name'), z.literal('email'), z.literal('phone'), z.literal('multiple')])
					.nullable(),
				validationRules: z.array(z.string()).nullable(),
				position: z.number(),
				options: z.array(
					z.object({
						id: z.string().uuid(),
						label: z.string(),
						position: z.number(),
						consentType: z.string().nullable(),
						escoSkills: z.array(
							z.object({
								conceptUri: z.string(),
								preferredLabel: z.string(),
								confirmedByUser: z.boolean(),
							}),
						).nullable(),
						escoMappingReason: z.string().nullable(),
					}),
				).nullable(),
				updatedAt: z.iso.datetime(),
			}),
		),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
		branding: z.object({
			id: z.string().nullable(),
			organisationId: z.string().nullable(),
			name: z.string().nullable(),
			website: z.string().nullable(),
			logoId: z.string().nullable(),
			logo: z.object({
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}).nullable(),
			toneOfVoice: z.string().nullable(),
			visualGuidance: z.string().nullable(),
			cornerRadius: z.string().nullable(),
			background: z.string(),
			foreground: z.string(),
			accentBackground: z.string(),
			accentForeground: z.string(),
			fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }),
			createdAt: z.iso.datetime().nullable(),
			updatedAt: z.iso.datetime().nullable(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
			generateKeyImage: z.boolean().default(true),
			generationError: z.union([z.literal('website_unreachable'), z.literal('scan_failed')]).nullable(),
		}).nullable(),
		closedAt: z.iso.datetime().nullable(),
		careerSiteSlug: z.string().nullable(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	id: z.string(),
	status: campaignDataStatusSchema,
	title: z.string(),
	requirements: z.string().nullable(),
	language: z.string(),
	notes: z.string().nullable(),
	location: z.string(),
	organisationId: z.string(),
	feed: z.object({
		id: z.string(),
		imageId: z.string().uuid().nullable(),
		image: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		imagesHistory: z.array(
			z.object({
				historyUpdatedAt: z.iso.datetime(),
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}),
		),
		campaignId: z.string().uuid(),
		organisationId: z.string().uuid(),
		title: z.string().nullable(),
		subtitle: z.string(),
		button: z.string(),
		location: z.string(),
		metaTitle: z.string(),
		metaDescription: z.string(),
		metaCallToAction: z.string(),
		metaPrimaryText: z.string(),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	story: z.object({
		id: z.string(),
		organisationId: z.string(),
		imageId: z.string().nullable(),
		image: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		imagesHistory: z.array(
			z.object({
				historyUpdatedAt: z.iso.datetime(),
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}),
		),
		campaignId: z.string(),
		title: z.string(),
		subtitle: z.string(),
		button: z.string(),
		location: z.string(),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	welcomeScreen: z.object({
		id: z.string(),
		title: z.string(),
		campaignId: z.string(),
		subtitle: z.string().nullable(),
		description: z.string().nullable(),
		descriptionHtml: z.string().nullable(),
		subtext: z.string().nullable(),
		imageId: z.string().nullable(),
		image: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		imagesHistory: z.array(
			z.object({
				historyUpdatedAt: z.iso.datetime(),
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}),
		),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		videoUrl: z.string().nullable(),
		updatedAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	invoiceUrl: z.string().nullable(),
	budget: z.number().nullable(),
	budgetBreakdown: z.object({ metaBudget: z.number(), serviceFee: z.number() }).nullable(),
	addons: z.array(
		z.object({
			id: z.string(),
			name: z.union([z.literal('Campaign Service'), z.literal('Contact Service')]),
			price: z.number(),
		}),
	).nullable(),
	customFields: z.array(z.object({ id: z.string(), name: z.string(), value: z.string() })).nullable(),
	branding: z.object({
		id: z.string().nullable(),
		organisationId: z.string().nullable(),
		name: z.string().nullable(),
		website: z.string().nullable(),
		logoId: z.string().nullable(),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		toneOfVoice: z.string().nullable(),
		visualGuidance: z.string().nullable(),
		cornerRadius: z.string().nullable(),
		background: z.string(),
		foreground: z.string(),
		accentBackground: z.string(),
		accentForeground: z.string(),
		fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }),
		createdAt: z.iso.datetime().nullable(),
		updatedAt: z.iso.datetime().nullable(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
		generateKeyImage: z.boolean().default(true),
		generationError: z.union([z.literal('website_unreachable'), z.literal('scan_failed')]).nullable(),
	}).nullable(),
	audience: z.string().nullable(),
	sourceWebsite: z.string().nullable(),
	generationError: z.string().nullable(),
	adCampaignLocations: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			country: z.object({ id: z.string(), name: z.string() }),
			region: z.object({ id: z.string(), name: z.string() }).nullable(),
		}),
	).nullable(),
	image: z.string().nullable(),
	storyImage: z.string().nullable(),
	careerSiteVisible: z.boolean(),
	channels: z.array(z.string()).nullable(),
	isEvergreen: z.boolean(),
	isArchived: z.boolean(),
	serviceFeePercent: z.number().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	startDate: z.iso.datetime().nullable(),
	endDate: z.iso.datetime().nullable(),
	submittedForReviewAt: z.iso.datetime().nullable(),
	submittedForReviewBy: z.string().nullable(),
	reviewedAt: z.iso.datetime().nullable(),
	reviewedBy: z.string().nullable(),
	metaAdCampaign: z.object({ startDate: z.iso.datetime().nullable(), endDate: z.iso.datetime().nullable() })
		.nullable(),
	candidateCount: z.number().nullable(),
	candidatesToday: z.number().nullable(),
	candidatesPerDay: z.array(z.number()).nullable(),
	hireCount: z.number().nullable(),
	accessors: z.array(
		z.object({
			id: z.string(),
			email: z.string(),
			firstname: z.string().nullable(),
			lastname: z.string().nullable(),
			role: z.string().nullable(),
		}),
	).nullable(),
	occupationClassification: z.object({
		code: z.string().optional(),
		label: z.string().optional(),
		isco_2_code: z.string().optional(),
		isco_2_label: z.string().optional(),
		isco_4_code: z.string().optional(),
		isco_4_label: z.string().optional(),
		esco_5_code: z.string().nullable().optional(),
		esco_5_label: z.string().nullable().optional(),
		esco_6_code: z.string().nullable().optional(),
		esco_6_label: z.string().nullable().optional(),
		reasoning: z.string().nullable().optional(),
	}).nullable(),
	firstContactAutomationEnabled: z.boolean().nullable(),
	firstContactScoreThreshold: z.number().nullable(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type CampaignDataSchema = z.infer<typeof campaignDataSchema>
